export const selectorCurrentUser = (state) => state.user.currentUser;
